import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import sha256 from 'crypto-js/sha256'
import { format } from 'date-fns'
import Evaporate from 'evaporate'
import sparkMd5 from 'spark-md5'
import { userApi } from '~/api'

export const setFileUploaded = createAction('user/setFileUploaded')
export const removeFileUploaded = createAction('user/removeFileUploaded')
export const setFileProcessing = createAction('user/setFileProcessing')
export const setFilePending = createAction('user/setFilePendingList')
export const setIsUploadDone = createAction('user/setIsUploadDone')

export const uploadFiles = createAsyncThunk(
  'course/uploadfiles',
  async (_, { dispatch, getState, rejectWithValue }) => {
    try {
      const state = getState()
      const { pendingFileList, uploadedFileList, data, isUploadDone } =
        state.course
      const id = data.id
      const { user, authToken } = state.auth

      if (pendingFileList && pendingFileList.length > 0) {
        const file = pendingFileList[0]
        if (
          uploadedFileList.length > 0 &&
          uploadedFileList.find((x) => x.file.path === file.path)
        ) {
          dispatch(
            setFileUploaded({
              file,
              status: 'exception',
              reason: 'Filename already exists.'
            })
          )
          dispatch(uploadFiles())
          return
        }

        if (isUploadDone) {
          return
        }
        dispatch(setIsUploadDone(true))

        const uploadAt = format(new Date(), 'dd-MM-yyyy')

        const path = `${id}/${uploadAt}/${file.name}`
        let uploadConfig
        try {
          const response = await userApi.getUploadConfiguration(data.id)
          uploadConfig = response.data
        } catch (reason) {
          dispatch(setFileUploaded({ file, status: 'exception', reason }))
          dispatch(uploadFiles())
          return
        }
        const config = {
          signerUrl: `/api/courses/${data.id}/sign-upload`,
          aws_key: uploadConfig.key,
          bucket: uploadConfig.bucket,
          awsRegion: uploadConfig.region,
          cloudfront: false,
          computeContentMd5: true,
          s3Acceleration: uploadConfig.accelerate,
          signHeaders: { Authorization: `Bearer ${authToken}` },
          cryptoMd5Method: (data) =>
            btoa(sparkMd5.ArrayBuffer.hash(data, true)),
          cryptoHexEncodedHash256: sha256
        }
        Evaporate.create(config).then(
          (eva) => {
            eva
              .add({
                name: path,
                file,
                progress: (progressValue) => {
                  dispatch(setFileProcessing({ file, progressValue }))
                }
              })
              .then(
                async () => {
                  await userApi.uploadCases(data.id, {
                    name: file.name,
                    size: file.size,
                    path,
                    uploader_id: user.id
                  })
                  dispatch(setFileUploaded({ file }))
                  dispatch(uploadFiles())
                },
                (reason) => {
                  dispatch(
                    setFileUploaded({
                      file,
                      status: 'exception',
                      reason
                    })
                  )
                  dispatch(uploadFiles())
                }
              )
          },
          (reason) => {
            dispatch(setFileUploaded({ file, status: 'exception', reason }))
            dispatch(uploadFiles())
          }
        )
        return
      }
      dispatch(setIsUploadDone(false))
      dispatch(setFileProcessing({}))
      return rejectWithValue({ response: 'Invalid request.' })
    } catch (e) {
      console.log('🚀 ~ file: action.js ~ line 90 ~ e', e)
      return rejectWithValue({
        response: e.response.data?.error
      })
    }
  }
)
